<template>
    <div class="app flex-row align-items-center">
        <div class="container">
            <b-row class="justify-content-center" v-if="(mustChangePwd==false)">
                <b-col md="8">
                    <b-card-group>
                        <b-card no-body class="p-4">
                            <b-card-body>
                                <b-form>
                                    <div class="text-center mb-4" style="margin-top:-20px">
                                        <img src="img/logo-esa.svg" height="60" alt="EkosSystem Logo">
                                    </div>
                                    <p class="text-muted">Sign In to your account</p>
                                    <b-input-group class="mb-3">
                                        <b-input-group-prepend>
                                            <b-input-group-text><i class="fa fa-user"></i></b-input-group-text>
                                        </b-input-group-prepend>
                                        <b-form-input type="text" class="form-control" ref="username" v-model="model.username" placeholder="Username" autocomplete="username" />
                                    </b-input-group>
                                    <b-input-group class="mb-4">
                                        <b-input-group-prepend>
                                            <b-input-group-text><i class="fa fa-lock"></i></b-input-group-text>
                                        </b-input-group-prepend>
                                        <b-form-input type="password" class="form-control" ref="password" v-model="model.password" placeholder="Password" autocomplete="current-password" @keyup.13.native="login()" />
                                    </b-input-group>
                                    <b-row>
                                        <b-col cols="6">
                                            <b-button variant="primary" class="px-4" @click="login()">Login</b-button>
                                        </b-col>
                                        <b-col cols="6" class="text-right">
                                            <!-- <b-button variant="link" class="px-0">Forgot password?</b-button> -->
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </b-card-body>
                        </b-card>
                        <!-- <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
                            <b-card-body class="text-center">
                                <div>
                                    <br>
                                    <br>
                                    <br>
                                    <b-button variant="primary" class="active mt-4" @click="register()">Register Now!</b-button>
                                </div>
                            </b-card-body>
                        </b-card> -->
                        <div class="card text-white bg-primary py-5 d-md-down-none" style="width:44%;">
                          <div class="card-body text-center">
                            <div style="margin-top: 20%;">
                              <img src="img/logo.png" height="80" alt="Company Logo" />
                            </div>
                          </div>
                        </div>
                    </b-card-group>
                </b-col>
            </b-row>
            <b-row class="justify-content-center" v-else>
                <b-col md="10">
                    <b-card-group>
                        <b-card no-body class="p-4">
                            <b-card-body>
                                    <p class="text-muted">Change Your Password</p>
                                    <b-input-group >
                                        <b-input-group-prepend><label>Current Password</label></b-input-group-prepend>
                                        <b-form-input type="password" placeholder="Enter current password" v-model="pwdObj.password" :state="!$v.pwdObj.password.$error"></b-form-input>
                                    </b-input-group>
                                    <b-input-group >
                                        <b-input-group-prepend><label>New Password</label></b-input-group-prepend>
                                        <b-form-input type="password" placeholder="Enter new password"  v-model="pwdObj.new_password" :state="!$v.pwdObj.new_password.$error"></b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-4">
                                        <b-input-group-prepend><label>Retype Password</label></b-input-group-prepend>
                                        <b-form-input type="password" placeholder="Re-type new password" v-model="pwdObj.confirm_password" :state="!$v.pwdObj.confirm_password.$error"></b-form-input>
                                    </b-input-group>
                                    <b-row>
                                        <b-col cols="6">
                                            <b-button variant="primary" class="px-4" @click="changePwd()">Change Password</b-button>
                                        </b-col>
                                        <b-col cols="6" class="text-right">
                                            <!-- <b-button variant="link" class="px-0">Forgot password?</b-button> -->
                                        </b-col>
                                    </b-row>
                            </b-card-body>

                        </b-card>
                        <!-- <b-card no-body style="width:44%">
                            <b-card-body>
                                    <p >Profile Info</p>
                                    <b-input-group >
                                        <b-input-group-prepend><label>Username</label></b-input-group-prepend>
                                        <b-form-input type="text" class="form-control" ref="username" v-model="model.username" readonly />
                                    </b-input-group>
                                    <b-input-group >
                                        <b-input-group-prepend><label>Email</label></b-input-group-prepend>
                                        <b-form-input type="email"  v-model="model.email" ></b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-4">
                                        <b-input-group-prepend><label>Mobile Phone</label></b-input-group-prepend>
                                        <b-form-input v-model="model.mobile" ></b-form-input>
                                    </b-input-group>
                                    <b-row>
                                        <b-col cols="6"> &nbsp;
                                        </b-col>
                                        <b-col cols="6" class="text-right">
                                        </b-col>
                                    </b-row>
                            </b-card-body>                      
                        </b-card> -->
                        <div class="card text-white bg-primary py-5 d-md-down-none" style="width:44%;">
                          <div class="card-body text-center">
                            <div style="margin-top: 20%;">
                              <img src="img/logo.png" height="80" alt="Company Logo" />
                            </div>
                          </div>
                        </div>

                    </b-card-group>
                </b-col>

            </b-row>  
        </div>
    </div>
</template>


<script>
import toastr from "mini-toastr";
import auth from "../apis/auth";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {   
  mixins: [validationMixin],
  validations: {
        pwdObj: {
            new_password: { required },
            confirm_password: { required },
            password: { required }
        },
  }, 
  computed: {
    invalidPassword() {
      this.$v.pwdObj.$touch();
      return this.$v.pwdObj.$invalid;
    },
  },

  data() {
    return {
      //   model: { username: "admin", password: "admin-123" },
       redirectPath:'',
       mustChangePwd:false,
      model: {},
      pwdObj:{new_password:'',confirm_password:'',password:''},
      clientDisabled: false
    };
  },
  created() {
    const { $route } = this;
    const { query } = $route;
    if (query && query.clientId) {
      this.model.client = query.clientId;
      this.clientDisabled = true;
    }
  },
  beforeCreate() {
    // this.redirectPath = window.location.pathname;
    const { $router, $store } = this;
    const { user } = $store.state;

    if (user.username) {
      const { group } = user;
    //   if (group === "admin") $router.push({ name: "admin" });
    //   if (group === "member") $router.push({ name: "app" });
        $router.push({ name: "app" });
    }
  },
  methods: {
    login: async function() {
      const { $router, $store } = this;
      const { username, password } = this.model;

      if (!username) return;
      if (!password) return;

      try {
        const tk = await auth.validate(this.model);
        const me = await auth.current();
        if (me.defaultpw==password) {
            this.mustChangePwd=true;
            toastr.warn('You have to change the password');
            this.model=me;
            return;
        }
        auth.save(tk, me);

        $store.commit("user", me);
        this.$socket.emit('notificationupdate', {key:'notifycount', user : me})

        if ($store.redirectPath) {
          console.log('Login redirectPath : ',$store.redirectPath);
          $router.replace($store.redirectPath);
        }  else {
          $router.push({ name: "app" });
        }

      } catch (error) {
        console.log('error : ', error);
        if (error.sql) {
            toastr.error(error.sql);
        } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage);
        } else if (error.message) {
            toastr.error(error.message);
        } else {
            toastr.error(JSON.stringify(error));
        }   

      }
    },
    changePwd: async function() {
        if (this.invalidPassword) {
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else if(this.pwdObj.new_password !== this.pwdObj.confirm_password) {
            toastr.error('konfirmasi password tidak sama','ERROR MESSAGE',10000);
            return;
        } else if(this.pwdObj.new_password == this.pwdObj.password) {
            toastr.error('password baru tidak boleh sama dengan password lama','ERROR MESSAGE',10000);
            return;
        } else {
            try {
                this.pwdObj.username=this.model.username;
                await auth.change_password(this.pwdObj);
                toastr.success('Change Password Successfully');
                this.model.password=this.pwdObj.new_password;
                this.login();
              } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage);
                } else if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }   

              }
        }
    },

    register() {
      this.$router.push({ name: "page.register" });
    }
  }
};
</script>
